<div class="modal-header" style="padding: 15px !important; border-bottom: 1px solid #e5e5e5;">
    <button type="button" class="close" data-dismiss="modal" aria-hidden="true" (click)="closeModal()">&times;</button>
    <h4 class="modal-title wrap-text-in">Job Profile</h4>
</div>

<div class="modal-body">
    <div>
        <app-job-profile [jobId]="modalData.jobId" (closeModalCallback)="closeModal()"></app-job-profile>
    </div>
</div>
